var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"bg-page",style:(_vm.bgPage)},[_c('div',{staticClass:"text-center",staticStyle:{"color":"black","background":"#ddd"}},[_c('h1',[_vm._v(_vm._s(_vm.msg))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }